import React from 'react'
import { BenefitsRoot, ImageWrapper, Body, BenefitsWrapper, MobileBody } from './Benefits.styles'
import { SectionTitle } from '../styles'
import Image, { StaticImageData } from 'next/image'
import { Box } from 'components/Box'
import { useTranslation } from 'hooks/useTranslation'
import { Proteins } from 'models/Pet'
import Trans from 'next-translate/Trans'

type BenefitsProps = {
  recipe: Proteins
  badge: StaticImageData
}

export const Benefits = ({ recipe, badge }: BenefitsProps) => {
  const { t } = useTranslation()

  return (
    <BenefitsRoot color={recipe}>
      <BenefitsWrapper>
        <Box>
          <SectionTitle>{t(`recipes:${recipe}.benefits.title`)}</SectionTitle>
          <Body>
            <Trans
              i18nKey={`recipes:${recipe}.benefits.description`}
              components={{ ul: <ul />, li: <li /> }}
            />
          </Body>
          <MobileBody>
            <Trans
              i18nKey={`recipes:${recipe}.benefits.description-m`}
              components={{ br: <br /> }}
            />
          </MobileBody>
        </Box>
        <ImageWrapper>
          <Image src={badge} alt={t(`recipes:${recipe}.benefits.img`)} />
        </ImageWrapper>
      </BenefitsWrapper>
    </BenefitsRoot>
  )
}

Benefits.displayName = 'Benefits'
